import mask from '~/plugins/mask/functions/directive';

// NOTE: Пакет https://www.npmjs.com/package/vue-the-mask адаптирован под Vue 3
export default defineNuxtPlugin(function (nuxtApp) {
  nuxtApp.vueApp.directive('mask', mask);
});